import React from 'react';
import PropTypes from 'prop-types';

const RegistrationComplete = ({ referralLink, copySuccess, onCopyLink, htmlId, className = '', ctaButtonText }) => (
  <div id={htmlId} className={`max-w-[1440px] mx-auto px-8 py-12 ${className}`}>
    <div className="max-w-[1152px]">
      <h1 className="text-[48px] font-bold leading-[62px] text-[#1C2938] mb-4"
        style={{ fontFamily: 'Poppins, sans-serif' }}>
        Thank you!
      </h1>

      <p className="text-[18px] font-normal leading-[23px] text-black mb-8"
        style={{ fontFamily: 'Poppins, sans-serif' }}>
        You are now signed up to be a part of Ship&Play&apos;s travel advisor registry.
      </p>

      <a
        href="/ship"
        className="inline-block px-8 py-3 text-white font-semibold text-[16px] leading-[20px]
          bg-[#1C2938] rounded-lg mb-10 no-underline"
        style={{ fontFamily: 'Poppins, sans-serif' }}
      >
        {ctaButtonText || 'Book now'}
      </a>

      {referralLink && (
        <div className="mb-8" data-testid="ta-referral-section">
          <h2 className="text-[24px] font-bold leading-[31px] text-[#1C2938] mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}>
            Share with your client!
          </h2>

          <div className="flex items-center gap-3">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="flex-shrink-0">
              <rect x="6" y="2" width="10" height="12" rx="1.5" stroke="#252525" strokeWidth="1.5"/>
              <path d="M4 6v10a1.5 1.5 0 001.5 1.5H14" stroke="#252525" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span className="text-[16px] font-normal text-black"
              data-testid="ta-referral-link"
              style={{ fontFamily: 'Poppins, sans-serif' }}>
              {referralLink}
            </span>
            <button
              type="button"
              onClick={onCopyLink}
              data-testid="ta-copy-link-button"
              className="text-[16px] font-semibold text-[#252525] underline bg-transparent
                border-none cursor-pointer ml-2"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {copySuccess ? 'Copied!' : 'Copy link'}
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
);

RegistrationComplete.propTypes = {
  referralLink: PropTypes.string,
  copySuccess: PropTypes.bool.isRequired,
  onCopyLink: PropTypes.func.isRequired,
  htmlId: PropTypes.string,
  className: PropTypes.string,
  ctaButtonText: PropTypes.string
};

export default RegistrationComplete;
